import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { PublishedShipments } from '@uturn/portal/modules/shipments';
import {
	SHIPMENTS_SEARCH_DEFAULT_STATUSES_PUBLISHED,
	ShipmentsSearchSchema,
	ShipmentsSearchStatusesSchema,
} from '@uturn/portal/router/schema/shipments-search';

const PublishedShipmentsSearchSchema = ShipmentsSearchSchema.extend({
	'filter.statuses': fallback(
		ShipmentsSearchStatusesSchema.array(),
		SHIPMENTS_SEARCH_DEFAULT_STATUSES_PUBLISHED,
	).default(SHIPMENTS_SEARCH_DEFAULT_STATUSES_PUBLISHED),
});

export const Route = createFileRoute('/_protected/shipments/(overview)/')({
	component: PublishedShipments,
	validateSearch: zodValidator(PublishedShipmentsSearchSchema),
});
